const getValueForPath = (pathArray: string | Array<string>, index: number, item: object): number | string | null => {
  if (typeof pathArray === 'string') {
    return getValueForPath(pathArray.split('.'), index, item)
  }
  if (typeof item === 'undefined' || !pathArray || typeof item[pathArray[index]] === 'undefined') {
    return null
  }
  if (pathArray.length - 1 === index) {
    return item[pathArray[index]]
  }
  return getValueForPath(pathArray, index + 1, item[pathArray[index]])
}

const getValuesForCompare = (
  dataKey: string,
  values: [object, object],
  sorts: Record<string, any>[],
  index: number,
  basedOnAdditionalData?: boolean,
  additionalData?: object,
) => {
  let currValue = `${getValueForPath(dataKey, 0, values[0]) || ''}`.toString()
  let nextValue = `${getValueForPath(dataKey, 0, values[1]) || ''}`.toString()
  if (basedOnAdditionalData) {
    currValue = `${getValueForPath(`${currValue}.${sorts[index].value}`, 0, additionalData) || ''}`.toString()
    nextValue = `${getValueForPath(`${nextValue}.${sorts[index].value}`, 0, additionalData) || ''}`.toString()
  }
  return { currValue, nextValue }
}

const compare = (
  values: [object, object],
  sorts: Record<string, any>[],
  index: number,
  additionalData: {} = {},
): number => {
  const basedOnAdditionalData = !!sorts[index].basedOnAdditionalData
  const additionalDataFirstKey = sorts[index].additionalDataFirstKey || ''
  let dataKey = sorts[index].value
  if (basedOnAdditionalData) {
    dataKey = additionalDataFirstKey
  }
  const { currValue, nextValue } = getValuesForCompare(
    dataKey,
    values,
    sorts,
    index,
    basedOnAdditionalData,
    additionalData,
  )

  let result = sorts[index].desc
    ? nextValue.localeCompare(currValue, 'cs', {
        numeric: true,
        sensitivity: 'base',
      })
    : currValue.localeCompare(nextValue, 'cs', {
        numeric: true,
        sensitivity: 'base',
      })

  index++

  if (result === 0 && sorts.length > index) {
    return compare([values[0], values[1]], sorts, index)
  }

  if (currValue < '0' && nextValue < '0') {
    result *= -1
  }

  return result
}

const sortArray = (array: any[], sorts: Record<string, any>[], additionalData: object = {}): any[] => {
  if (!array || array.length === 0) {
    return []
  }
  if (!sorts || sorts.length === 0) {
    return array
  }
  if (sorts.length === 1 && !array.some((i) => Number.isNaN(i) || typeof i !== 'number')) {
    return array.sort((currItem, nextItem): number => {
      if (currItem < nextItem) {
        return sorts[0]?.desc ? 1 : -1
      }
      if (currItem > nextItem) {
        return sorts[0]?.desc ? -1 : 1
      }
      return 0
    })
  }
  return array.sort((currItem, nextItem) => compare([currItem, nextItem], sorts, 0, additionalData))
}

export default sortArray
